/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import moment from "moment";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Svg,
  Path,
  Font
} from "@react-pdf/renderer";
import { ClipLoader } from 'react-spinners';
// import { bindActionCreators } from 'redux';
// import ActionCreators from '../../actions';
// import { setLyftReportData } from '../../utils/functions';
// import { imageBaseUrl } from "../utils/api";
import TicketImg from '../../Assets/tickimg.png';
import LyftImg from '../../Assets/lyftimg.png';
import lyftCheckBox from "../../Assets/lyftCheckBox.png";
// import { height } from "dom-helpers";
import kalamFont from '../../font/Kalam-Light.ttf';
import '../../font/registerPatrickHandAndCaveatPdf';
import {
  lyftArkansasColumns,
  getLyftArkansasPointStatus,
} from "./lyftArkansasInspectionData";
import { handDrawnCirclePath } from "../../utils/handDrawnCircle";

Font.register({ family: 'kalamFont', format: "truetype", src: kalamFont });


const styles = StyleSheet.create({
  body: {
    paddingBottom: 5,
  },
  headerWidth: {
    // paddingHorizontal: 10,
    marginBottom: "25px",
  },
  header: {
    backgroundColor: "#00B3AD",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
  },
  imgwrap:{
    flexDirection:"row",
    alignItems: "center",

  },
  textborder:{
     marginLeft:"20px",
     color:"white",
     borderLeft:"1px solid white",
     paddingLeft:"20px",
     height:"100%",
      textTransform:"uppercase",
     fontWeight:"bold"
  },
  californiaText: {
    color: "white",
    fontSize: "20px",
    textTransform: "uppercase",
  },
  boxContainer: {
    padding: "10px",
  },
  lyftdrivertextContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent:"space-between",
    marginBottom: "15px",
  },
  boxWidth: {
    paddingHorizontal: 20,
    // paddingTop: 10,
  },
  lyftdriverText: {
    fontSize: "24px",
    fontStyle: "sans-serif",
    fontWeight: "bold",
    // lineHeight: "42px",
    color: "black",
    // fontFamily: "sans-serif",
    float: "left"
  },
  allfieldsText: {
    color: "black",
    fontSize: "18px",
    fontWeight: "400",
    marginLeft: "200px",
  },
  nameinputContainer: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    // width: "100%",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "30px"
  },
  nameinputContain: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    // width: "100%",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px"
  },
  lyftdriverName: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "23px",
    color: "#47484F",
    marginBottom: 0,
    // width:"100px",
    marginTop: "3px",
  },
  lyftdriver: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "23px",
    color: "#47484F",
    marginBottom: 0,
    // width:"100px",
    marginTop: "3px",
    borderTop: "3px solid #A6A4A4",
    paddingTop: "5px"
  },
  nameText: {
    fontSize: "16px",
    fontStyle: "normal",
    // fontFamily: 'kalamFont',
    fontWeight: "400",
    // lineHeight: "23px",
    textAlign: "center",
    color: "black",
    // width: "100%",
    borderBottom: "3px solid #A6A4A4"
  },
  threeinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "30px"
  },
  nameinputContainerOne: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    width: "30%",
    marginRight: "10px",
  },
  nameinputContainerTwo: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    width: "30%",
    marginRight: "10px",
  },
  nameinputContainerThree: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    marginTop: "10px",
    width: "40%",
  },
  threeinputFields: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
    // lineHeight: "23px",
    color: "black",
    textAlign: "center",
    // fontFamily: 'kalamFont',
    borderBottom: "3px solid #A6A4A4"
  },
  threeinputField: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
    // lineHeight: "23px",
    color: "black",
    // fontFamily: 'kalamFont',
    paddingLeft: "20px",
    borderBottom: "3px solid #A6A4A4"
  },
  threeinputFieldsStreetAddress: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "300",
    // lineHeight: "23px",
    color: "black",
    textAlign: "center",
    // fontFamily: 'kalamFont',
    borderBottom: "3px solid #A6A4A4"
  },
  licenseplateContainer: {
    // borderWidth: 1,
    // borderColor: "#47484F",
    width: "45%",
    marginRight: "10px",
  },
  codeText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "300",
    // lineHeight: "23px",
    color: "black",
    marginLeft: "50%",
  },
  vinContainer: {
    fontSize: "12px",
    fontWeight: "30",
    fontStyle: "normal",
    color: "black",
  },
  twoinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px",
  },
  vintopBorder: {
    borderTopWidth: 1,
    borderTopColor: "#47484F",
    width: "100%",
  },
  topText: {
    marginTop: "30px",
    fontSize: "12px",
    paddingLeft: "8px",
    paddingRight: "10px",
  },
  vehicleinspectionPadding: {
    paddingHorizontal: "30px",
    paddingTop: "10px",
  },
  checkboxesmainContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
  },
  checkboxesmainContainerTwo: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
    marginTop: "10px",
  },
  inspectionfirstContainer: {
    width: "94%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionsecondContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionText: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  detailsText2: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    // lineHeight: '21px',
    color: 'gray',
    marginLeft: '25px',
  },
  inspectiontextTwo: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    marginLeft: "15px",
    textTransform: "uppercase",
  },
  passText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    marginRight: "15px",
    textTransform: "uppercase",
  },
  failText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  passfailContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  passfailContainer1: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft:"223px"
  },
  numbersText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
  },
  detailsText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "black",
    marginLeft: "5px",
  },
  failpassbox: {
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "black",
    marginLeft: "15px",
    width: "92%",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    position: "absolute",
    height: "60px",
    top: 10,
  },

  boxinspectionText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    // lineHeight: "21px",
    color: "black",
    textTransform: "uppercase",
  },
  circleoneText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "21px",
    color: "#716E6E",
    marginTop: "5px",
  },
  boxpassText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "black",
  },
  orangeCircle: {
    borderWidth: 5,
    borderColor: "#FC6522",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  boxfailText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "black",
  },
  boxinspectionContainer: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  tobecompletedContainer: {
    backgroundColor: "#E4E5E7",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedWidth: {
    paddingHorizontal: "30px",
    marginTop: '10px',
  },
  tobecompletedtextContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedText: {
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "23px",
    color: "black",
    textDecoration: "underline",
    textTransform: "uppercase",
  },
  fieldsText: {
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },

  inpectionText: {
    fontSize: "16px",
    color: "#47484F",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  documentexpiryText: {
    fontSize: "12px",
    color: "#47484F",
  },
  dateText: {
    fontSize: "16px",
    letterSpacing: "1px",
  },
  datemainContainer: {
    marginTop: "10px",
    marginLeft: "52%",
  },
  namesfieldscontainer: {
    flexDirection: "row",
    // alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "18px",
    alignItems: "flex-end",
  },
  borderWidth: {
    borderBottomWidth: 1,
    borderBottomColor: "black",
  },
  topName: {
    fontSize: "14px",
    color: "black",
    marginLeft: "12px",
  },
  bottomName: {
    fontSize: "12px",
    color: "#47484F",
    textTransform: "uppercase",
  },
  bottomPara: {
    paddingHorizontal: "30px",
    fontSize: 10,
    marginTop: "15px",
    color: "#716E6E",
  },
  tickpassContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  tickfailContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  inspectiondateContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "95%",
  },
  arkChecklist: {
    paddingHorizontal: "30px",
    marginTop: "5px",
    marginBottom: "10px",
  },
  arkChecklistTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#3a3b43",
    marginBottom: "12px",
  },
  arkColumns: { flexDirection: "row" },
  arkColLeft: { width: "50%", paddingRight: "20px" },
  arkColRight: { width: "50%", paddingLeft: "20px" },
  arkPointsHeader: {
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: "6px",
  },
  arkPhLabel: {
    flex: 1,
    fontSize: "10px",
    textTransform: "uppercase",
    color: "#8a8a8a",
  },
  arkPhOpt: {
    width: "34px",
    fontSize: "9px",
    textAlign: "center",
    textTransform: "uppercase",
    color: "#8a8a8a",
  },
  arkPointRow: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: "21px",
  },
  arkPointLabel: { flex: 1, flexDirection: "row" },
  arkPointNum: { width: "16px", fontSize: "10px", color: "#8a8a8a" },
  arkPointName: {
    flex: 1,
    fontSize: "11px",
    fontWeight: "bold",
    color: "#2b2c33",
  },
  arkSubName: { flex: 1, fontSize: "10px", color: "#4a4b52" },
  arkCheckCell: {
    width: "34px",
    alignItems: "center",
    justifyContent: "center",
  },
  arkCheckbox: {
    width: "12px",
    height: "12px",
    borderWidth: 1,
    borderColor: "#1a1a1a",
    alignItems: "center",
    justifyContent: "center",
  },
  arkCheckTick: { width: "10px" },
  arkResultBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: "#1a1a1a",
    padding: "14px 12px",
    marginTop: "24px",
  },
  arkResultTitle: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#2b2c33",
    flex: 1,
  },
  arkResultNote: { fontSize: "10px", fontWeight: "normal", color: "#6f6f6f" },
  arkResultOption: {
    position: "relative",
    width: "44px",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "8px",
  },
  arkResultOptionText: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#2b2c33",
  },
  arkHandCircle: {
    position: "absolute",
    top: "-10px",
    left: "-14px",
    width: "72px",
    height: "40px",
  },
});

const ArkHandCircle = () => (
  <Svg style={styles.arkHandCircle} viewBox="0 0 112 73">
    <Path
      d={handDrawnCirclePath}
      stroke="#000000"
      strokeWidth={4}
      strokeLinecap="round"
      fill="none"
    />
  </Svg>
);

const ArkPdfCheckbox = ({ checked }) => (
  <View style={styles.arkCheckCell}>
    <View style={styles.arkCheckbox}>
      {checked ? <Image style={styles.arkCheckTick} source={TicketImg} /> : null}
    </View>
  </View>
);

function LyftCertificateArkansasDownLoad ({
  checksData,
  reportData,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };
  const finalStatus = reportData?.finalStatus;

    const checksname=[
        {
          id:1,
         name:"Left front"
        },
        {
          id:2,
          name:"Right front"
        },
       {
        id:3,
        name:"Left rear"
       },
       {
        id:4,
        name:"Right rear"
       }
      ]

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width, min A3 height) so the certificate always fits on a single page */}
            <Page size={{ width: 841.89 }} style={[styles.body, { minHeight: 1190.55 }]} wrap={false}>
              <View style={styles.headerWidth}>
                <View style={styles.header}>
                <View style={styles.imgwrap}>
                  <Image style={{ width: "40px" }} source={LyftImg} />
                  </View>
                  <Text style={[styles.californiaText, { fontWeight: "bold" }]}>
                    VEHICLE INSPECTION
                  </Text>
                </View>
              </View>
              <View style={{ paddingHorizontal: "30px", marginBottom: "15px" }}>
                <Text style={{ fontSize: "16px", color: "#3a3b43", lineHeight: 1.35, fontWeight: "bold", marginHorizontal: "30px" }}>
                  Note: This inspection shall be performed or supervised by a mechanic certified by the National Institute for Automotive Service Excellence.
                </Text>
              </View>
              <View style={styles.boxWidth}>
                <View style={styles.boxContainer}>
                  <View style={styles.lyftdrivertextContainer}>
                    <Text style={styles.lyftdriverText}>LYFT DRIVER INFO</Text>
                    <Text style={styles.allfieldsText}>
                      ALL FIELDS ARE MANDATORY
                    </Text>
                  </View>

                  <View style={styles.nameinputContainer}>
                    <View style={{ width: "50%", marginRight: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {reportData && `${reportData?.Username} ${reportData?.UserlastName}`}
                      </Text>
                      <Text style={styles.lyftdriverName}>LYFT DRIVER NAME</Text>
                    </View>
                    <View style={{ width: "50%", marginLeft: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {reportData && reportData?.Useremail}
                      </Text>
                      <Text style={styles.lyftdriverName}>EMAIL ADDRESS</Text>
                    </View>
                  </View>
                  <View style={styles.threeinputfieldContainer}>
                    <View style={styles.nameinputContainerOne} >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.licensePlateNumber}
                      </Text>
                      <Text style={styles.lyftdriverName}>LICENSE PLATE #</Text>
                    </View>
                    <View style={[styles.nameinputContainerTwo, { width: "auto", flexGrow: 1, marginRight: 0 }]} >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.vin}
                      </Text>
                      <Text style={styles.lyftdriverName}>VIN #</Text>
                    </View>
                  </View>
                  <View style={styles.twoinputfieldContainer}>
                    <View style={styles.licenseplateContainer} >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.make}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE MAKE</Text>
                    </View>
                    <View style={{ width: "32%", marginRight: "10px", marginLeft: "5px" }}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.model}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE MODEL</Text>
                    </View>
                    <View style={{ width: "20%", marginLeft: "18px" }}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.year}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE YEAR</Text>
                    </View>
                  </View>
                  <View style={styles.nameinputContain}>
                    <View style={{ width: "45%", marginRight: "10px", marginTop: "15px" }}>
                      {/* <Image
                          style={{
                            position: "absolute",
                            height: "100px",
                            width: "100px",
                            top: "-50px",
                            right: "100px",
                          }}
                          src={`${process.env.REACT_APP_AWS_S3_LINK}/${
                            reportData && reportData.Inspectorsignature
                          }?x-request=xhr`}
                        /> */}
                      <Text style={styles.lyftdriver}>LYFT DRIVER SIGNATURE</Text>
                    </View>
                    <View style={{ width: "55%", marginLeft: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {reportData && reportData?.Userphone}
                      </Text>
                      <Text style={styles.lyftdriverName}>LYFT DRIVER PHONE NUMBER</Text>
                    </View>
                  </View>
                </View>
              </View>
              {/* <View style={styles.vehicleinspectionPadding}>
                <View style={styles.lyftdrivertextContainer}>
                  <Text style={styles.lyftdriverText}>INSPECTION CHECKLIST</Text>
                </View>
              </View> */}
              {/* height converted from 38% of A3 (page is now auto-height) to a fixed value */}
              <View style={styles.arkChecklist}>
                <Text style={styles.arkChecklistTitle}>INSPECTION CHECKLIST</Text>
                <View style={styles.arkColumns}>
                  {lyftArkansasColumns.map((col, colIdx) => (
                    <View
                      style={colIdx === 0 ? styles.arkColLeft : styles.arkColRight}
                      key={colIdx}
                    >
                      <View style={styles.arkPointsHeader}>
                        <Text style={styles.arkPhLabel}>INSPECTION POINT</Text>
                        <Text style={styles.arkPhOpt}>PASS</Text>
                        <Text style={styles.arkPhOpt}>FAIL</Text>
                      </View>
                      {col.map((point) => {
                        const status = getLyftArkansasPointStatus(
                          checksData,
                          point.number - 1
                        );
                        return (
                          <React.Fragment key={point.number}>
                            <View style={styles.arkPointRow}>
                              <View style={styles.arkPointLabel}>
                                <Text style={styles.arkPointNum}>
                                  {point.number}.
                                </Text>
                                <Text style={styles.arkPointName}>
                                  {point.label}
                                </Text>
                              </View>
                              <ArkPdfCheckbox checked={status.pass} />
                              <ArkPdfCheckbox checked={status.fail} />
                            </View>
                            {point.subItems
                              ? point.subItems.map((sub) => (
                                  <View style={styles.arkPointRow} key={sub}>
                                    <View style={styles.arkPointLabel}>
                                      <Text style={styles.arkPointNum}> </Text>
                                      <Text style={styles.arkSubName}>{sub}</Text>
                                    </View>
                                    <ArkPdfCheckbox checked={status.pass} />
                                    <ArkPdfCheckbox checked={status.fail} />
                                  </View>
                                ))
                              : null}
                          </React.Fragment>
                        );
                      })}

                      {colIdx === 1 ? (
                        <View style={styles.arkResultBox}>
                          <Text style={styles.arkResultTitle}>
                            VEHICLE INSPECTION{" "}
                            <Text style={styles.arkResultNote}>(Circle One)</Text>
                          </Text>
                          <View style={styles.arkResultOption}>
                            {finalStatus === "pass" ? <ArkHandCircle /> : null}
                            <Text style={styles.arkResultOptionText}>PASS</Text>
                          </View>
                          <View style={styles.arkResultOption}>
                            {finalStatus === "fail" ? <ArkHandCircle /> : null}
                            <Text style={styles.arkResultOptionText}>FAIL</Text>
                          </View>
                        </View>
                      ) : null}
                    </View>
                  ))}
                </View>
              </View>
              {/* <View style={{ flexDirection: "row", paddingHorizontal: "30px" }}>
                <View style={{ flexDirection: "column", width: "50%" }}>
                  <View style={styles.inspectionfirstContainer}>
                    <Text style={styles.inspectionText}>INSPECTION POINT</Text>
                    <View style={styles.passfailContainer}>
                      <Text style={styles.passText}>PASS</Text>
                      <Text style={styles.failText}>FAIL</Text>
                    </View>
                  </View>

                  {checksData?.map((check, index) =>
                    index <= 11 ? (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <Text style={styles.numbersText}>{index + 1}.</Text>
                          <Text style={styles.detailsText}>{check.Check.name}</Text>
                        </View>
                        <View style={styles.passfailContainer}>
                          {check.status == true || check.status == 1 ? (
                            <View style={styles.tickpassContainer}>
                              <Image
                                style={{ width: "16px", marginLeft: "2px" }}
                                source={TicketImg}
                              />
                            </View>
                          ) : (
                            <View style={styles.tickpassContainer}></View>
                          )}
                          {check.status == false || check.status == 0 ? (
                            <View style={styles.tickfailContainer}>
                              <Image
                                style={{ width: "16px", marginLeft: "2px" }}
                                source={TicketImg}
                              />
                            </View>
                          ) : (
                            <View style={styles.tickfailContainer}></View>
                          )}
                        </View>
                      </View>
                    ) : null
                  )}
                </View>

                <View style={{ flexDirection: "column", width: "50%" }}>
                  <View style={styles.inspectionfirstContainer}>
                    <Text style={styles.inspectionText}>INSPECTION POINT</Text>
                    <View style={styles.passfailContainer}>
                      <Text style={styles.passText}>PASS</Text>
                      <Text style={styles.failText}>FAIL</Text>
                    </View>
                  </View>

                  {checksData?.map((check, index) =>
                    index > 11 ? (
                      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px' }}>
                        { index === 16 ? (
                          <View>
                           <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <View style={{flexDirection:"row"}}>
                          <Text style={styles.numbersText}>{index+1}</Text>
                          <Text style={styles.detailsText}>{check?.Check?.name}</Text>
                          </View>
                          <View style={styles.passfailContainer1}>
                          {check?.status == true || check?.status == 1 ? (
                            <View style={styles.tickpassContainer}>
                              <Image style={{ width: '16px', marginLeft: '2px' }} source={TicketImg} />
                            </View>
                          ) : (
                            <View style={styles.tickpassContainer}></View>
                          )}
                          {check?.status == false || check?.status == 0 ? (
                            <View style={styles.tickfailContainer}>
                              <Image style={{ width: '16px', marginLeft: '2px' }} source={TicketImg} />
                            </View>
                          ) : (
                            <View style={styles.tickfailContainer}></View>
                          )}
                        </View>
                          </View>
                           {checksname.map((checkName,index)=>{
                               return(
                                 <View  key={index} style={{ flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <View style={{marginTop:'10px'}}>
                                    <Text style={styles.detailsText2}>{checkName.name}</Text>
                                    </View>
                                    <View style={styles.passfailContainer}>
                                        {check?.status == true || check?.status == 1 ? (
                                            <View style={styles.tickpassContainer}>
                                            <Image style={{ width: '16px', marginLeft: '2px' }} source={TicketImg} />
                                            </View>
                                        ) : (
                                            <View style={styles.tickpassContainer}></View>
                                        )}
                                        {check?.status == false || check?.status == 0 ? (
                                            <View style={styles.tickfailContainer}>
                                            <Image style={{ width: '16px', marginLeft: '2px' }} source={TicketImg} />
                                            </View>
                                            ) : (
                                            <View style={styles.tickfailContainer}></View>
                                            )}
                                    </View>
                                </View>
                               );
                             })
                           }
                        </View>
                        ) :
                            <>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                          <Text style={styles.numbersText}>{index + 1}.</Text>
                          <Text style={styles.detailsText}>{check?.Check?.name}</Text>
                        </View>
                        <View style={styles.passfailContainer}>
                          {check?.status == true || check?.status == 1 ? (
                              <View style={styles.tickpassContainer}>
                              <Image style={{ width: '16px', marginLeft: '2px' }} source={TicketImg} />
                            </View>
                          ) : (
                              <View style={styles.tickpassContainer}></View>
                              )}
                          {check?.status == false || check?.status == 0 ? (
                              <View style={styles.tickfailContainer}>
                              <Image style={{ width: '16px', marginLeft: '2px' }} source={TicketImg} />
                            </View>
                          ) : (
                              <View style={styles.tickfailContainer}></View>
                              )}
                        </View>
                        </>
                            }
                      </View>
                    )   : null
                    )}

                    <View
                    style={[
                      styles.inspectionsecondContainer,
                      { marginTop: "20px", marginLeft: -10 },
                    ]}
                  >
                    <View style={styles.failpassbox}>
                      <View style={styles.boxinspectionContainer}>
                        <Text style={styles.boxinspectionText}>
                          VEHICLE INSPECTION
                        </Text>
                        <Text style={styles.circleoneText}>
                          (Please circle one)
                        </Text>
                      </View>
                      {reportData &&
                        reportData.finalStatus === "pass" ? (
                        <View style={styles.orangeCircle}>
                          <Text style={styles.boxpassText}>PASS</Text>
                        </View>
                      ) : (
                        <Text style={styles.boxpassText}>PASS</Text>
                      )}
                      {reportData &&
                        reportData.finalStatus === "fail" ? (
                        <View style={styles.orangeCircle}>
                          <Text style={styles.boxpassText}>FAIL</Text>
                        </View>
                      ) : (
                        <Text style={styles.boxpassText}>FAIL</Text>
                      )}
                    </View>
                  </View>
                </View>
              </View> */}
              <View style={styles.tobecompletedWidth}>
                <View style={styles.tobecompletedContainer}>
                  <View style={{ width: "50%", marginLeft: "20px", marginTop: "10px", marginRight: "20px" }}>
                    <Text>TO BE COMPLETED BY INSPECTOR</Text>
                  </View>
                </View>
                <View style={styles.tobecompletedContainer}>
                  <View style={{ width: "50%", marginLeft: "20px", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>Chex Inc.</Text>
                    <Text style={styles.lyftdriverName}>COMPANY/FACILITY NAME</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>{`${reportData && reportData?.Inspectorname} ${reportData && reportData?.InspectorlastName}`}</Text>
                    <Text style={styles.lyftdriverName}>INSPECTOR NAME</Text>
                  </View>
                </View>
                <View style={[styles.tobecompletedContainer, { alignItems: "flex-end" }]}>
                  <View style={{ width: "50%", marginLeft: "20px", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputFieldsStreetAddress, handwritingStyle]}>{reportData && reportData?.stateAddress}</Text>
                    <Text style={styles.lyftdriverName}>COMPANY/FACILITY ADDRESS</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }} >
                    <Text style={[styles.threeinputField, handwritingStyle]}>
                      {moment(
                        new Date(
                          reportData &&
                          reportData?.reviewedDate
                        )
                      ).format("MM/ DD /YYYY")}
                    </Text>
                    <Text style={styles.lyftdriverName}>INSPECTION DATE (document expires one year from this date)</Text>
                  </View>
                </View>
                <View style={[styles.tobecompletedContainer, { alignItems: "flex-end" }]}>
                  <View style={{ width: "50%", marginRight: "20px", marginLeft: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>{(reportData && reportData?.milage) || " "}</Text>
                    <Text style={styles.lyftdriverName}>VEHICLE MILEAGE</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }} >
                    <Text style={[styles.threeinputField, handwritingStyle]}>{(reportData && reportData?.aseCertificationNumber) || " "}</Text>
                    <Text style={styles.lyftdriverName}>ASE/AATI CERTIFICATION NO.</Text>
                  </View>
                </View>
                <View style={[styles.tobecompletedContainer, { alignItems: "flex-start" }]}>
                  <View style={{ width: "50%", marginLeft: "20px", marginRight: "20px", marginBottom: "10px" }}>
                    <View style={{ position: "relative" }}>
                      {reportData && reportData?.Inspectorsignature ? (
                        <Image
                          style={{ position: "absolute", bottom: 0, left: "20px", height: "50px", width: "150px", objectFit: "contain" }}
                          source={`${process.env.REACT_APP_AWS_S3_LINK}/${reportData.Inspectorsignature}?x-request=xhr`}
                        />
                      ) : null}
                      <Text style={[styles.threeinputField, handwritingStyle]}>{" "}</Text>
                    </View>
                    <Text style={styles.lyftdriverName}>INSPECTOR SIGNATURE</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>{" "}</Text>
                    <Text style={styles.lyftdriverName}>NAME OF SUPERVISING AATI OR ASE CERTIFIED MECHANIC (IF DIFFERENT FROM ABOVE)</Text>
                  </View>
                </View>
              </View>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const LyftCertificateArkansasDownLoadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template3");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <LyftCertificateArkansasDownLoad
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.lyftVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setLyftReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LyftCertificateArkansasDownLoadConnected);
